import type { RedirectRouteRelative } from '@/utilities/routers.ts'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTodoCreate,
  detail: routeTodoDetail,
  home: routeTodosHome,
  root: routeTodosRoot,
} = createDoctypeRoutes({
  createName: 'new-todo',
  createPath: 'new-todo',
  detailName: 'todoDetail',
  doctype: DOCTYPES.TODO,
  homeName: 'todos',
  path: 'todo',
  views: {
    create: async () => await import('@/components/viewsExternal/todo/AddTodo.vue'),
    detail: async () => await import('@/components/viewsExternal/todo/ViewTodo.vue'),
    list: async () => await import('@/components/viewsExternal/todo/TodoView.vue'),
  },
})

const redirectTodosDetail: RedirectRouteRelative = {
  name: routeTodoDetail.name,
}

export { redirectTodosDetail, routeTodoCreate, routeTodoDetail, routeTodosHome, routeTodosRoot }
